<template>
  <div class="container container-table logincontainer">
<div class="spinner" style="">
    <div class="loadingtext">{{loadingtext}}</div>
  <div class="loader">Loading...</div>
  </div>
    <div class="row vertical-10p">
      <div class="container">
        <img src="/static/img/velocity_login_logo.svg" class="center-block logina-logo">
        <div class="text-center col-md-4 col-sm-offset-4">
          <!-- login form -->
          <form class="ui form loginForm" @submit.prevent="checkCreds">

            <div class="input-group">
              <span class="input-group-addon">
                <i class="fa fa-envelope"></i>
              </span>
              <input class="form-control" name="username" placeholder="Username" type="text" v-model="username">

            </div>
  <div class="loginforget">Forgot username? <a href="https://www.yammer.com/dentsuaegis.com/#/threads/inGroup?type=in_group&feedId=14264485&view=all" target="blank">contact in yammer</a> </div>
            <button type="submit" v-bind:class="'btn btn-primary btn-lg ' + loading">Submit</button>
          </form>

          <!-- errors -->
          <div v-if=response class="text-red">
            <p>{{response}}</p>
          </div>
        </div>
      </div>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
  </div>
</template>

<script>
import Simplert from 'vue2-simplert'
import $ from 'jquery'
export default {
  name: 'Login',
  components: { Simplert },
  data (router) {
    return {
      loadingtext: '',
      section: 'Login',
      loading: '',
      username: '',
      response: '',
      XpiKey_prod: 'SFZMWjLFzd6MxLmgHw5Kk4MFMENTRQOa34AcnNVg',
      ApiURL_prod: 'https://7uzb1bv3pc.execute-api.eu-west-1.amazonaws.com/prod',
      XpiKey_dev: '9rMnjaACpH1FEx7l1X7uU8XP1MU6wCMyIcqpdtDf',
      ApiURL_dev: 'https://bjgimmvuwh.execute-api.eu-west-1.amazonaws.com/dev',
      XpiKey_qa: 'NRG4MOLYjH402FpP4ryQVLhJgXqv4NL8NT4TFqm8',
      ApiURL_qa: 'https://53hh1vlaih.execute-api.eu-west-1.amazonaws.com/qa',
      defaultjodid: 'ee163972-5a95-4e70-8f6b-33131534ab1e'
    }
  },
  methods: {
    displaypopuperr () {
      let err = {
        title: 'Error',
        message: 'Your Login credentials are incorrect',
        type: 'error',
        customClass: 'error'
      }
      this.$refs.simplert.openSimplert(err)
    },
    getApptype () {
      function getSubdomain (hostname) {
        var regexParse = new RegExp('[a-z-0-9]{2,63}[a-z.]{2,5}$')
        var urlParts = regexParse.exec(hostname)
        return hostname.replace(urlParts[0], '').slice(0, -1)
      }
      getSubdomain(window.location.hostname)
      var locationbr = getSubdomain(window.location.hostname)
      var jobid = 'job-id=' + this.defaultjodid
      window.localStorage.setItem('JobId', jobid)
      window.localStorage.setItem('XpiKey', this.XpiKey_dev)
      window.localStorage.setItem('ApiURL', this.ApiURL_dev)
      if (locationbr === 'velocity') {
        window.localStorage.setItem('XpiKey', this.XpiKey_prod)
        window.localStorage.setItem('ApiURL', this.ApiURL_prod)
      } else if (locationbr === 'dev-velocity') {
        window.localStorage.setItem('XpiKey', this.XpiKey_dev)
        window.localStorage.setItem('ApiURL', this.ApiURL_dev)
      } else if (locationbr === 'beta-velocity') {
        window.localStorage.setItem('XpiKey', this.XpiKey_qa)
        window.localStorage.setItem('ApiURL', this.ApiURL_qa)
      } else if (locationbr === 'new-qa') {
        window.localStorage.setItem('XpiKey', this.XpiKey_dev)
        window.localStorage.setItem('ApiURL', this.ApiURL_dev)
      }
    },
    checkCreds () {
      var self = this
      // const {username} = thisIs
      // this.toggleLoading()
      // this.resetResponse()
      // this_is.$store.commit('TOGGLE_LOADING')
      self.getApptype()
      $('.spinner').hide()
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/VelocityUserAuthentication',
        data: { 'user-id': self.username },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.loadingtext = 'processing...'
          $('.spinner').show()
        },
        complete: function () {
          $('.spinner').hide()
        },
        success: function (data) {
          console.log(data['user-data'])
          data = data['user-data']
          // var mydata = data[0]['name']
          // data[0]['name'] = [].concat(...mydata)
          console.log(data)
          if (!data) {
            $('.spinner').hide()
            self.displaypopuperr()
          }
          data = JSON.parse(data)
          if (data) {
            // var token = 'Bearer ' + data.token
            self.$parent.$store.commit('SET_USER', self.username)
            // this.$store.commit('SET_TOKEN', token)
            if (window.localStorage) {
              window.localStorage.setItem('user', self.username)
              window.localStorage.setItem('username', data.name)
              window.localStorage.setItem('email', data.email)
              // window.localStorage.setItem('token', token)
            }
            self.$router.push('/')
          } else {
            window.localStorage.setItem('user', null)
            window.localStorage.setItem('email', null)
            window.localStorage.setItem('username', null)
            window.localStorage.setItem('token', null)
            window.localStorage.setItem('XpiKey', null)
            window.localStorage.setItem('ApiURL', null)
            self.displaypopuperr()
            return
          }
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          $('.spinner').hide()
          self.displaypopuperr()
        }
      })
      /* Making API call to authenticate a user */
      /*
      api.request('post', '/login', {username, password})
      .then(response => {
        this.toggleLoading()

        var data = response.data
        /* Checking if error object was returned from the server */
      /*
              if (data.error) {
                var errorName = data.error.name
                if (errorName) {
                  this.response = errorName === 'InvalidCredentialsError'
                  ? 'Username/Password incorrect. Please try again.'
                  : errorName
                } else {
                  this.response = data.error
                }

                return
              }
             /* Setting user in the state and caching record to the localStorage
              if (data.user) {
                var token = 'Bearer ' + data.token

                this.$store.commit('SET_USER', data.user)
                this.$store.commit('SET_TOKEN', token)

                if (window.localStorage) {
                  window.localStorage.setItem('user', JSON.stringify(data.user))
                  window.localStorage.setItem('token', token)
                }
                this.$router.push(data.redirect)
              }
            })
            .catch(error => {
              this.$store.commit('TOGGLE_LOADING')
              console.log(error)

              this.response = 'Server appears to be offline'
              this.toggleLoading()
            })
          },
          toggleLoading () {
            this.loading = (this.loading === '') ? 'loading' : ''
          },
          resetResponse () {
            this.response = ''
          }
          */
    }
  }
}
</script>

<style>
.logina-logo {
  width: 150px !important;
  margin-bottom: 30px;
  max-height: 130px;
}
.error .simplert__body,
.error .simplert__title {
  color: red !important;
}
html,
body,
.container-table {
  height: 100%;
}
.container-table {
  display: table;
  color: white;
}
.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.logo {
  width: 15em;
  padding: 3em;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
}
.input-group input {
  height: 4em;
}
.container.container-table.logincontainer {
  margin-top: 8%;
}
.loginforget {
  font-size: 14px;
  text-align: center;
  color: #000;
  margin-bottom: 15px;
}
.loginforget a, .loginforget a:hover {
  color: #000;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// Login.vue?9849b07e